module.exports = __webpack_public_path__ + "img/licence5.c519149d.jpg";